'use client';

import { c as _c } from "react/compiler-runtime";
import { Flag } from '@7f-ui/components/flag/flag';
import { BeachChair } from '@7f-ui/components/icons/beach-chair';
import type { BeachChairStatus } from '@data-access/graphql/schema.types';
import { Backpack, House } from '@phosphor-icons/react';
type Props = {
  experienceCount: number;
  accommodationCount: number;
  beachChairStatus: BeachChairStatus;
};
export function Flags(t0) {
  const $ = _c(10);
  const {
    experienceCount,
    accommodationCount,
    beachChairStatus
  } = t0;
  let t1;
  if ($[0] !== experienceCount) {
    t1 = experienceCount > 0 && <Flag Icon={Backpack}>{`${experienceCount} ${experienceCount === 1 ? "Erlebnis" : "Erlebnisse"}`}</Flag>;
    $[0] = experienceCount;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== accommodationCount) {
    t2 = accommodationCount > 0 && <Flag Icon={House}>{`${accommodationCount} ${accommodationCount === 1 ? "Unterkunft" : "Unterk\xFCnfte"}`}</Flag>;
    $[2] = accommodationCount;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== beachChairStatus) {
    t3 = beachChairStatus === "beachChairsAvailable" && <Flag Icon={BeachChair}>Strandkörbe</Flag>;
    $[4] = beachChairStatus;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex flex-wrap gap-2">{t1}{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}